import React from "react";
import styles from "../../styles/winterpay.module.css";

//윈터스쿨 셀프 결제 — 작은 UI 조각들 (아이콘·드롭다운·달력·상담 시트·헤더)

export const cx = (...names: (string | false | null | undefined)[]) => names.filter(Boolean).join(" ");

export const IconChevronDown = ({ size = 16, stroke = "#8B95A1" }: { size?: number; stroke?: string }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.4"><path d="m6 9 6 6 6-6" /></svg>
);
export const IconChevronRight = ({ size = 16 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"><path d="m9 18 6-6-6-6" /></svg>
);
export const IconChevronLeft = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0A1931" strokeWidth="1.5"><path d="m15 18-6-6 6-6" /></svg>
);
export const IconCheck = ({ size = 16, stroke = "currentColor", width = 2 }: { size?: number; stroke?: string; width?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth={width} strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
);
export const IconClock = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5v4.59l3.2 3.2-1.41 1.42L11 12.41V7h2Z" /></svg>
);
export const IconSeat = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M5 11V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5" /><path d="M3 11h18v4H3z" /><path d="M6 15v5" /><path d="M18 15v5" /></svg>
);
export const IconHeadset = () => (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z" /><path d="M21 16v2a4 4 0 0 1-4 4h-5" /></svg>
);
export const IconPhone = () => (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.81.36 1.6.7 2.34a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.74-1.27a2 2 0 0 1 2.11-.45c.74.34 1.53.57 2.34.7A2 2 0 0 1 22 16.92z" /></svg>
);
export const IconKakao = () => (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor" aria-hidden="true"><path d="M12 4C7.03 4 3 7.13 3 10.99c0 2.42 1.62 4.55 4.06 5.77-.18.64-.65 2.36-.74 2.73-.12.46.17.45.35.33.14-.09 2.27-1.54 3.19-2.17.36.05.74.08 1.14.08 4.97 0 9-3.13 9-7C21 7.13 16.97 4 12 4z" /></svg>
);
export const IconCopy = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
);
export const IconUpload = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="M17 8l-5-5-5 5" /><path d="M12 3v12" /></svg>
);

//상담 시트 (전화·카카오)
export const ContactSheet = ({ onClose }: { onClose: () => void }) => (
    <div className={styles.sheetWrap}>
        <div className={styles.sheetBack} onClick={onClose} />
        <div className={styles.sheet}>
            <div className={styles.sheetHandle} />
            <h3 className={styles.sheetTitle}>결제 중 궁금한 점, <b>바로 물어보세요</b></h3>
            <p className={styles.sheetSub}>입력한 내용은 그대로 남아 있어요.</p>
            <div className={styles.sheetLinks}>
                <a href="tel:1668-5786" className={styles.sheetLink}>
                    <span className={styles.sheetIcon}><IconPhone /></span>
                    <span><span className={styles.sheetLinkTitle}>전화로 상담하기</span><span className={styles.sheetLinkSub}>지금 바로 연결해 드려요</span></span>
                </a>
                <a href="https://pf.kakao.com/_Whxexgxj/chat" target="_blank" rel="noopener noreferrer" className={styles.sheetLink}>
                    <span className={styles.sheetIcon}><IconKakao /></span>
                    <span><span className={styles.sheetLinkTitle}>카카오톡으로 상담하기</span><span className={styles.sheetLinkSub}>편한 시간에 답장 받으세요</span></span>
                </a>
            </div>
        </div>
    </div>
);

//드롭다운 (지점 선택)
export interface DdOption { value: string; label: string; }
export const Dropdown = ({ value, options, placeholder, open, onToggle, onPick }: { value: string; options: DdOption[]; placeholder: string; open: boolean; onToggle: () => void; onPick: (v: string) => void }) => {
    const cur = options.find(o => o.value === value);
    return (
        <div className={styles.dd} data-dd="">
            <button type="button" className={cx(styles.ddBtn, open && styles.ddBtnOpen, !cur && styles.ddPlaceholder)} aria-haspopup="listbox" aria-expanded={open} onClick={onToggle}>
                {cur ? cur.label : placeholder}
            </button>
            <span className={cx(styles.ddChev, open && styles.ddChevOpen)}><IconChevronDown /></span>
            {open && (
                <div role="listbox" className={styles.ddMenu}>
                    {options.map(o => (
                        <button type="button" role="option" aria-selected={o.value === value} key={o.value} className={cx(styles.ddOpt, o.value === value && styles.ddOptOn)} onClick={() => onPick(o.value)}>
                            <span>{o.label}</span>
                            <span style={{ visibility: o.value === value ? "visible" : "hidden", color: "#0A1931" }}><IconCheck width={1.75} /></span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

//세그먼트 버튼 그룹
export const SegGroup = ({ items, value, onChange, columns }: { items: { value: string; label: string }[]; value: string; onChange: (v: string) => void; columns?: number }) => (
    <div role="radiogroup" className={styles.grid2} style={columns ? { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` } : undefined}>
        {items.map(it => (
            <button type="button" role="radio" aria-checked={value === it.value} key={it.value} className={cx(styles.seg, value === it.value && styles.segOn)} onClick={() => onChange(it.value)}>{it.label}</button>
        ))}
    </div>
);

//한 달 달력 (시작일 선택)
export interface CalCell { day: number | ""; empty: boolean; off: boolean; outside: boolean; sel: boolean; today: boolean; onClick: (() => void) | null; }
export const Calendar = ({ title, cells, prevVis, nextVis, onPrev, onNext }: { title: string; cells: CalCell[]; prevVis: boolean; nextVis: boolean; onPrev: () => void; onNext: () => void }) => (
    <div className={styles.cal}>
        <div className={styles.calHead}>
            <button type="button" aria-label="이전 달" className={cx(styles.calNav, !prevVis && styles.calNavHidden)} onClick={onPrev}><IconChevronLeft /></button>
            <span className={styles.calTitle}>{title}</span>
            <button type="button" aria-label="다음 달" className={cx(styles.calNav, !nextVis && styles.calNavHidden)} onClick={onNext}><span style={{ transform: "rotate(180deg)", display: "flex" }}><IconChevronLeft /></span></button>
        </div>
        <div className={styles.calWeek}>{["일", "월", "화", "수", "목", "금", "토"].map(w => <span key={w}>{w}</span>)}</div>
        <div className={styles.calGrid}>
            {cells.map((c, i) => (
                <div className={styles.calCell} key={i}>
                    <button type="button" disabled={c.empty || c.off || c.outside}
                        className={cx(styles.calDay, c.empty && styles.calDayEmpty, c.outside && styles.calDayOutside, !c.outside && c.off && styles.calDayOff, c.today && !c.sel && styles.calDayToday, c.sel && styles.calDaySel)}
                        onClick={c.onClick || undefined}>{c.day}</button>
                </div>
            ))}
        </div>
    </div>
);

//key-value 목록 (결제완료·대기 화면)
export const KvList = ({ rows }: { rows: [string, string][] }) => (
    <div className={styles.kvList}>
        {rows.map(([k, v]) => <div className={styles.kv} key={k}><span>{k}</span><span>{v}</span></div>)}
    </div>
);
